import _ from 'lodash';
/**
 * set game points value in multiStage (define in static/MULTIBOOK_TYPE/games/pages/config.js)
 */
// config.multiStageGameWeight= 4
//

const state = {
  gameObj: {},
  gameData: {},
  gameActive: false,
  resetGame: false,
  checkGame: false,
  gameAudio: '',
  /**
   * game status
   * @type {String}      ['unset','correct','incorrect']
   *                     unset: default value;
   *                     correct:show correct icon  ;
   *                     incorrect:show incorrect icon
   */
  actualGameStatus: 'unset',
  /**
   * stage type         ['singleStage','multiStage']
   *                    singleStage:default value;
   * @type {String}
   */
  gameStageType: 'singleStage',
  /**
   * in multistage describe how next work (define in static/MULTIBOOK_TYPE/config/pages/pageXXX.js)
   *                      ['cycle','linear']
   *                        cycle: default
   * @type {String}
   */
  multiStageCrawlerType: 'cycle',
  /** in the configuration, describes whether the games are to be randomized(define in static/MULTIBOOK_TYPE/config/pages/pageXXX.js)
   *                        false: default
   * @type {Boolean}
   */
  multiStageShuffle: false,
  nextButtonStatus: true,
  currentStage: 0,
  stages: [],
  blockCheckAction: false,
  blockReset: false,
  blockCheck: false,
  gameCheckSwitch: false,
  gameCheckCJS: false,
  componentKey: 0,
  /**
   * visibility Points UI
   *                      false:default
   * @type {Boolean}
   */
  multistageVisiblePointsUI: false,
  multistageSkipCorrect: true,
};

const mutations = {
  SET_GAMEOBJ(state, data) {
    state.gameObj = data;
  },
  SET_GAME_AUDIO(state, data) {
    state.gameAudio = data;
  },
  RESET_GAMEOBJ(state) {
    state.gameObj = {};
  },
  SHUFFLE_GAMEOBJECT(state, data) {
    if (state.gameObj.items && state.gameStageType === 'multiStage') {
      state.gameObj.items = data;
      state.stages = data.map((item, index) => {
        if (item.item && item.item.gameConfig && item.item.gameConfig.withoutCheck) {
          return { status: 'correct', value: 0, check: false };
        } else {
          return { status: 'unset', value: item.item.multiStageGameWeight || 1, check: true };
        }
      });
    }
  },
  CHANGE_GAME_CONTENT(state, data) {
    state.gameData = data;
  },

  RESET_GAME_CONTENT(state) {
    state.gameData = {};
  },

  CHANGE_GAME_ACTIVE(state, gameActive) {
    state.gameActive = gameActive;
  },
  CHANGE_GAME_TYPE(state, gameStageType) {
    state.gameStageType = gameStageType;
  },
  CHANGE_MULTISTAGE_TYPE(state, multiStageCrawlerType) {
    state.multiStageCrawlerType = multiStageCrawlerType;
  },
  CHANGE_VISIBILITY_POINTS_UI(state, multistageVisiblePointsUI) {
    state.multistageVisiblePointsUI = multistageVisiblePointsUI;
  },
  CHANGE_MULTISTAGE_SKIP_CORRECT(state, multistageSkipCorrect) {
    state.multistageSkipCorrect = multistageSkipCorrect;
  },
  CHANGE_ACTUAL_GAME_STATUS_TO_INCORRECT(state) {
    if (state.blockCheckAction) {
      state.actualGameStatus = 'correct';
    } else {
      state.actualGameStatus = 'incorrect';
    }
    // state.gameData.gameStatus = false;
  },
  CHANGE_ACTUAL_GAME_STATUS_TO_CORRECT(state) {
    state.actualGameStatus = 'correct';
    // state.gameData.gameStatus = true;
  },
  RESET_ACTUAL_GAME_STATUS(state) {
    if (state.blockCheckAction) {
      state.actualGameStatus = 'correct';
    } else {
      state.actualGameStatus = 'unset';
    }

    // state.gameData.gameStatus = true;
  },
  CHANGE_BLOCK_CHECK_ACTION(state, payload) {
    state.blockCheckAction = payload;
    // state.gameData.gameStatus = true;
  },
  CHANGE_BLOCK_RESET_ACTION(state, payload) {
    state.blockReset = payload;
    // state.gameData.gameStatus = true;
  },
  CHANGE_BLOCK_CHECK(state, payload) {
    state.blockCheck = payload;
    // state.gameData.gameStatus = true;
  },
  CHECK_GAME(state, payload) {
    state.checkGame = payload;
  },
  ENABLE_NEXT_BUTTON(state) {
    state.nextButtonStatus = true;
  },
  DISABLE_NEXT_BUTTON(state) {
    state.nextButtonStatus = false;
  },

  RESET_GAME(state, payload) {
    state.resetGame = payload;
    // state.gameData.gameStatus = true;
  },
  CHANGE_CHECK_SWITCH(state, payload) {
    state.gameCheckSwitch = payload;
  },
  CHANGE_CHECK_CJS(state, payload) {
    state.gameCheckCJS = payload;
  },
  SET_STAGES(state, payload) {
    state.stages = payload;
  },
  RESET_STAGES(state) {
    state.stages = [];
  },
  SET_MULTISTAGE_SHUFFLE(state, payload) {
    state.multiStageShuffle = payload;
  },
  CHANGE_CURRENT_STAGE(state, payload) {
    state.currentStage = payload;
  },
  // incorrect
  // correct
  // unset
  CHANGE_ACTUAL_STAGE_STATUS_TO_CORRECT(state) {
    state.stages = state.stages.map((item, index) => {
      if (index === state.currentStage) {
        item.status = 'correct';
      }
      return item;
    });
  },
  // incorrect
  // correct
  // unset
  CHANGE_ACTUAL_STAGE_STATUS_TO_INCORRECT(state) {
    state.stages = state.stages.map((item, index) => {
      if (index === state.currentStage) {
        if (state.blockCheckAction) {
          item.status = 'correct';
        } else {
          item.status = 'incorrect';
        }
      }
      return item;
    });
  },
  CHANGE_ACTUAL_STAGE_STATUS_TO_UNSET(state) {
    state.stages = state.stages.map((item, index) => {
      if (index === state.currentStage) {
        if (state.blockCheckAction) {
          item.status = 'correct';
        } else {
          item.status = 'unset';
        }
      }
      return item;
    });
  },
  CHANGE_COMPONENET_KEY(state) {
    state.componentKey += 1;
  },
};

const actions = {
  newGame(context, payload) {
    if (context.getters.multiStageTest && !_.isEmpty(payload.items[context.getters.currentStage])) {
      payload = payload.items[context.getters.currentStage];
    }
    console.log('dispatch newGame', payload);
    context.commit('RESET_GAME_CONTENT');
    context.commit('CHANGE_GAME_CONTENT', payload);
    context.commit('CHANGE_COMPONENET_KEY');
    context.commit('CHECK_GAME', false);
    context.commit('RESET_ACTUAL_GAME_STATUS');
    context.commit('CHANGE_CHECK_CJS', false);
    if (payload.item.gameConfig.withoutCheck) {
      context.commit('CHANGE_BLOCK_CHECK_ACTION', true);
      context.commit('CHANGE_CHECK_SWITCH', true);
    } else {
      context.commit('CHANGE_BLOCK_CHECK_ACTION', false);
      context.commit('CHANGE_CHECK_SWITCH', false);
    }
    if (payload.item.gameConfig.withoutReset) {
      context.commit('CHANGE_BLOCK_RESET_ACTION', true);
    } else {
      context.commit('CHANGE_BLOCK_RESET_ACTION', false);
    }
    if (payload.item.gameConfig.blockCheck) {
      context.commit('CHANGE_BLOCK_CHECK', true);
    } else {
      context.commit('CHANGE_BLOCK_CHECK', false);
    }
    context.commit('CHANGE_GAME_ACTIVE', true);
  },
  nextStage(context) {
    if (context.getters.multiStageCrawlerType === 'linear') {
      if (context.getters.stages.length > context.getters.currentStage + 1) {
        context.commit('CHANGE_CURRENT_STAGE', context.getters.currentStage + 1);
      }
      if (context.getters.stages.length <= context.getters.currentStage + 1) {
        context.commit('DISABLE_NEXT_BUTTON');
      }
    } else {
      let n = context.getters.currentStage;
      // console.log('PREV n', n);
      if (
        context.getters.multistageSkipCorrect &&
        context.getters.stages.filter((item) => {
          return item.status != 'correct';
        }).length > 0
      ) {
        do {
          n = (n + 1) % context.getters.stages.length;
        } while (
          (context.getters.stages[n].check && context.getters.stages[n].status === 'correct') ||
          (!context.getters.stages[n].check && context.getters.stages[n].status != 'correct')
        );
        context.commit('CHANGE_CURRENT_STAGE', n);
      } else {
        context.commit('CHANGE_CURRENT_STAGE', (n + 1) % context.getters.stages.length);
      }
    }

    context.dispatch('newGame', context.getters.gameObj);
  },
  setGameObject(context, payload) {
    context.commit('SET_GAMEOBJ', payload);
    if (context.getters.multiStageTest && payload.items) {
      context.commit('CHANGE_MULTISTAGE_TYPE', payload.multiStageCrawlerType);
      if (_.isBoolean(payload.multistageVisiblePointsUI)) {
        context.commit('CHANGE_VISIBILITY_POINTS_UI', payload.multistageVisiblePointsUI);
      }
      if (_.isBoolean(payload.multistageSkipCorrect)) {
        context.commit('CHANGE_MULTISTAGE_SKIP_CORRECT', payload.multistageSkipCorrect);
      }
      const data = payload.items.map((item, index) => {
        if (item.item && item.item.gameConfig && item.item.gameConfig.withoutCheck) {
          return { status: 'correct', value: 0, check: false };
        } else {
          return { status: 'unset', value: item.item.multiStageGameWeight || 1, check: true };
        }
      });
      context.commit('SET_STAGES', data);
      context.commit('CHANGE_CURRENT_STAGE', 0);
      context.commit('ENABLE_NEXT_BUTTON');
    }
  },
  resetGame(context) {
    context.commit('RESET_ACTUAL_GAME_STATUS');
    if (context.getters.multiStageTest) {
      context.commit('CHANGE_ACTUAL_STAGE_STATUS_TO_UNSET');
    }
    context.commit('RESET_GAME', false);
    if (context.state.blockCheckAction) {
      context.commit('CHANGE_BLOCK_CHECK_ACTION', true);
      context.commit('CHANGE_ACTUAL_GAME_STATUS_TO_CORRECT');
      context.commit('CHANGE_CHECK_SWITCH', true);
    } else {
      context.commit('CHANGE_CHECK_SWITCH', false);
    }
  },
  closeGame(context) {
    context.commit('CHANGE_GAME_ACTIVE', false);
    context.commit('RESET_GAME_CONTENT');
    context.commit('RESET_GAMEOBJ');
    context.commit('RESET_STAGES');
    context.commit('CHANGE_CURRENT_STAGE', 0);
    context.commit('CHANGE_GAME_TYPE', 'singleStage');
    context.commit('CHANGE_MULTISTAGE_TYPE', 'cycle');
    context.commit('CHANGE_VISIBILITY_POINTS_UI', false);
  },
  resetCheckStatus(context) {
    if (context.state.blockCheckAction) {
      context.commit('CHANGE_CHECK_SWITCH', true);
    } else {
      context.commit('CHANGE_CHECK_SWITCH', false);
    }
  },
  // updateGameConfig(context, payload) {
  //   // console.log( 'updateGameConfig' );
  //   let _gameData = _.cloneDeep(state.gameData);
  //   _gameData.item.gameConfig = payload;
  //   context.commit('CHANGE_GAME_CONTENT', _gameData);
  // },
  checkGame(context, payload) {
    context.commit('CHECK_GAME', true);
    if (payload && context.getters.multiStageTest) {
      context.commit('CHANGE_ACTUAL_GAME_STATUS_TO_CORRECT');
      context.commit('CHANGE_ACTUAL_STAGE_STATUS_TO_CORRECT');
      if (
        context.getters.multistageSkipCorrect &&
        context.getters.stages.filter((item) => {
          return item.status != 'correct';
        }).length <= 0
      ) {
        context.commit('DISABLE_NEXT_BUTTON');
      }
    } else if (payload) {
      context.commit('CHANGE_ACTUAL_GAME_STATUS_TO_CORRECT');
    } else if (context.getters.multiStageTest) {
      context.commit('CHANGE_ACTUAL_GAME_STATUS_TO_INCORRECT');
      context.commit('CHANGE_ACTUAL_STAGE_STATUS_TO_INCORRECT');
    } else {
      context.commit('CHANGE_ACTUAL_GAME_STATUS_TO_INCORRECT');
    }
    context.commit('CHANGE_CHECK_SWITCH', true);
    // context.commit('CHECK_GAME', false);
  },

  disablingCheckAction(context) {
    context.commit('CHANGE_BLOCK_CHECK_ACTION', true);
    context.commit('CHANGE_ACTUAL_GAME_STATUS_TO_CORRECT');
    context.commit('CHANGE_CHECK_SWITCH', true);
    // context.commit( 'CHECK_GAME_RESET' );
  },
};

const getters = {
  gameData: (state) => {
    return state.gameData;
  },
  gameAudio: (state) => {
    return state.gameAudio;
  },
  checkGame: (state) => {
    return state.checkGame;
  },
  resetGame: (state) => {
    return state.resetGame;
  },
  gamePath: (state) => {
    return state.gameData.item && state.gameData.item.gamePath;
  },
  gameActive: (state) => {
    return state.gameActive;
  },
  actualGameStatus: (state) => {
    return state.actualGameStatus;
  },
  blockCheckAction: (state) => {
    return state.blockCheckAction;
  },
  blockResetAction: (state) => {
    return state.blockReset;
  },
  blockCheck: (state) => {
    return state.blockCheck;
  },
  gameCheckSwitch: (state) => {
    return state.gameCheckSwitch;
  },
  gameCheckCJS: (state) => {
    return state.gameCheckCJS;
  },
  gameStageType: (state) => {
    return state.gameStageType;
  },
  singleStageTest: (state) => {
    return state.gameStageType === 'singleStage';
  },
  multiStageTest: (state) => {
    return state.gameStageType === 'multiStage';
  },
  stages: (state) => {
    return state.stages;
  },
  stagesCorrectStatus: (state) => {
    const status = _.reduce(
      state.stages,
      (acc, item) => {
        if (!item.check) {
          return acc;
        }
        return acc && item.status === 'correct';
      },
      true
    );
    return status;
  },
  stagesMaxPoints: (state) => {
    const status = _.reduce(
      state.stages,
      (acc, item) => {
        if (!item.check) {
          return acc;
        }
        return acc + item.value;
      },
      0
    );
    return status;
  },
  stagesCurrentPointStatus: (state) => {
    const status = _.reduce(
      state.stages,
      (acc, item) => {
        if (!item.check || item.status != 'correct') {
          return acc;
        }
        return acc + item.value;
      },
      0
    );
    return status;
  },
  currentStage: (state) => {
    return state.currentStage;
  },
  maxStage: (state) => {
    return state.stages.length;
  },
  gameObj: (state) => {
    return state.gameObj;
  },
  /**
   * engin version from config.js in static/games
   * @param {*} state
   */
  // Example /static/something/game/page000_game0/config.js:
  //
  // var config = {
  // engine: 'testMulti',
  // engineVersion: 'v2',
  // gameConfig: dataConfig,
  // title: [
  //   {
  //     text: `Przeczytaj zagadki. Zaznacz właściwe odpowiedzi.`,
  //   },
  // ],
  // (...)
  gameEngineVersion: (state) => {
    /** default version */
    let resp = 'v4';
    if (state.gameObj?.item?.engineVersion) {
      resp = state.gameObj.item.engineVersion;
    }
    return resp;
  },
  multiStageCrawlerType: (state) => {
    return state.multiStageCrawlerType;
  },
  multistageVisiblePointsUI: (state) => {
    return state.multistageVisiblePointsUI;
  },
  multistageSkipCorrect: (state) => {
    return state.multistageSkipCorrect;
  },
  nextButtonStatus: (state) => {
    return state.nextButtonStatus;
  },
  multiStageShuffle: (state) => {
    return state.multiStageShuffle;
  },
  componentKey: (state) => {
    return state.componentKey;
  },
};
export default { state, mutations, actions, getters };
